<div class="last-reviewed-container">
  <p *ngIf="reviewedInfo() as reviewedInfo; else noReviewer">
    {{ 'commonLabels.reviewedBy' | xTranslate }}
    <span>{{ reviewedInfo.reviewedBy }}</span>
    {{ 'commonLabels.reviewedOn' | xTranslate }}
    <span>{{ reviewedInfo.reviewedOn | getDateString: 'MM/DD/YYYY' }}</span>
  </p>
  <button mat-icon-button color="primary" (click)="addReviewer()" *ngIf="hasEDPWriteAccess">
    <mat-icon class="sp-edit" matTooltipPosition="above" [matTooltip]="tooltipMsg | xTranslate">edit</mat-icon>
  </button>
</div>

<ng-template #noReviewer>
  <p>
    {{ 'commonLabels.reviewedBy' | xTranslate }}
    <span>-</span>
    {{ 'commonLabels.reviewedOn' | xTranslate }}
    <span>-</span>
  </p>
</ng-template>
